import * as React from 'react'

import NavBar from '../../components/Navbar'
import Routes from '../Routes'

import guard from '../../services/Guard'

export default class App extends React.Component<{}, {}> {
  render() {
    if (!new guard().shouldRoute()) {
      return <Routes />
    }
    else {
      return (
        <div>
          <NavBar title="Bonduelle API Portal" />
          <Routes />
        </div>
      )
    }
  }
}
